// extracted by mini-css-extract-plugin
export default {"body_styleDefault":"c-a_fE","body_styleRed":"c-a_fF"};